//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import camItem from '~/components/content/cam/cam_new_card.vue'
import dummyItem from '~/components/content/dummy/video_dummy.vue'
import filters from '~/components/content/cam/filters_cam';
import highlightedCams from '~/components/content/cam/highlightedCams';
import activefilters from '~/components/content/cam/filters/active_filters_cam';
import registerButton from '~/components/content/cam/registerButton';
import mobileFilters from '~/components/content/cam/filters/mobileFilters';
export default {
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('pagesStore/getPage', 'webcams'),
      this.$store.dispatch('camStore/getCams', this.camsQuery)
      ])
  },
  head() {
    return {
      title: this.pages.webcams ? this.pages.webcams.seo.title : 'Secret Circle | Hollandse webcam meiden',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.webcams ? this.pages.webcams.seo.title : 'Secret Circle | Hollandse webcam meiden' },
        { hid: 'og:title', name: 'og:title', content: this.pages.webcams ? this.pages.webcams.seo.title : 'Secret Circle | Hollandse webcam meiden' },
        { hid: 'description', name: 'description', content: this.pages.webcams ? this.pages.webcams.seo.description : 'Geile webcamseks met 100% Nederlandse dames die live op jou zitten te wachten op Secret Circle. Sexchat hier met een verzameling aan hete, rijpe en exotische meiden.'},
        { hid: 'og:description', name: 'og:description', content: this.pages.webcams ? this.pages.webcams.seo.description : 'Geile webcamseks met 100% Nederlandse dames die live op jou zitten te wachten op Secret Circle. Sexchat hier met een verzameling aan hete, rijpe en exotische meiden.' },
        { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/webcams' },
        { hid: 'keywords', name: 'keywords', content: this.pages.webcams ? this.pages.webcams.seo.keywords : 'webcams, cams, webcam seks'},
        ]
    }
  },
  components: {
    camItem,
    registerButton,
    mobileFilters,
    dummyItem,
    filters,
    highlightedCams,
    activefilters,
  },
  computed: {
    ...mapState({
      pages: ({ pagesStore: {pages} }) => pages,
      cams: ({ camStore: { cams } }) => cams,
      camsQuery: ({ camStore: {camsQuery} }) => camsQuery,
      loading: ({ camStore: {loading} }) => loading,
      camFilter: ({ camStore: { camFilter } }) => camFilter,
    }),
  },
  methods: {
    loadMore() {
      let loadmoreQuery = JSON.parse(JSON.stringify(this.camsQuery));
      loadmoreQuery.page = this.camsQuery.page + 1 ;
      this.$store.commit('camStore/updateQuery', loadmoreQuery);
      this.$store.dispatch('camStore/getCams', loadmoreQuery);
    }
  },
};
